module.exports = __webpack_public_path__ + "media/images/patent/z_7-23447acff6411c0610a68777cf92a527.png";